export class DocumentDomain {
  static INVOICE: string = "invoice";
  static BILL: string = "bill";
  static EXPENSE: string = "expense";
  static MOVEMENT: string = "movement";
  static DOCUMENT: string = "document";
}
